import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../Components/Content/Main/main.css";
import Chart from "chart.js/auto";
import axios from "axios";
import {
  getUserId,
  getDepId,
  GetavailableLeave,
  HEADERS,
  getOrgId,
  getroleName,
  monthlyuserreport,
  GetUser,
  GetenabledLeave,
  getLeaPId,
} from "../api";

const Dashboard = () => {
  const [usergetall, setusergetall] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");
  const [leaveTypeData, setLeaveTypeData] = useState([]);
  const chartRef1 = useRef(null);
  const chartRef2 = useRef(null);
  const [monthlydata, setmonthlydata] = useState([]);
  const chartInstances = useRef([]);
  const roleName = getroleName();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      const OrgID = getOrgId();
      const DepId = getDepId();
      const loggedInUserId = getUserId();

      try {
        const requestData = { org_id: OrgID, dept_id: DepId };
        const response = await axios.post(GetUser, requestData, {
          headers: HEADERS,
        });
        if (
          response.data?.response_code === "0000" &&
          Array.isArray(response.data?.data)
        ) {
          setusergetall(response.data.data); // Ensure we are setting data correctly
          // console.log('Fetched users:', response.data.data);
          const defaultUser = response.data.data.find(
            (user) => user.user_id === loggedInUserId
          );
          if (defaultUser) {
            setSelectedUser(
              `${defaultUser.user_id}::${defaultUser.leave_policy}`
            );
          }
        } else {
          console.error("Error fetching users. Please try again later.");
        }
      } catch (error) {
        console.error("An error occurred while fetching users:", error);
      } finally {
        setLoading(false); // Set loading to false after the API call completes
      }
    };

    fetchUserData();
  }, []);

  useEffect(() => {
    const fetchmonthlyData = async () => {
      const UserID = getUserId();
      try {
        const requestData = { user_id: UserID };
        const response = await axios.post(monthlyuserreport, requestData, {
          headers: HEADERS,
        });
        // console.log("response:", response.data)
        if (response.data.response_code === "0000") {
          setmonthlydata(response.data.data);
        } else {
          // console.error("Error fetching leave type. Please try again later.");
        }
      } catch (error) {
        // console.error("An error occurred while fetching leave type:", error);
      }
    };

    fetchmonthlyData();
  }, []);

  useEffect(() => {
    fetchDataDefault();
    fetchData();
  }, [getLeaPId()]);

  const fetchDataDefault = async () => {
    // $&
    // Same as above
    try {
      const enabledLeaveTypesResponse = await axios.post(
        GetenabledLeave,
        { lp_id: getLeaPId() },
        { headers: HEADERS }
      );
      if (enabledLeaveTypesResponse.data.response_code === "0000") {
        const enabledLeaveTypes = enabledLeaveTypesResponse.data.data;

        const leaveTypeDataPromises = enabledLeaveTypes.map(
          async (leaveType) => {
            const leaveTypeResponse = await axios.post(
              GetavailableLeave,
              { user_id: getUserId(), leave_type: leaveType.leave_type_id },
              { headers: HEADERS }
            );
            if (leaveTypeResponse.data.response_code === "0000") {
              return leaveTypeResponse.data.data[0];
            }
            return null;
          }
        );

        const leaveTypeDataResults = await Promise.all(leaveTypeDataPromises);
        const filteredLeaveTypeData = leaveTypeDataResults.filter(
          (data) => data !== null
        );
        setLeaveTypeData(filteredLeaveTypeData);
      } else {
        console.error("Error fetching enabled leave types.");
      }
    } catch (error) {
      console.error("Error fetching leave data:", error);
    }
  };
  const fetchData = async (user_id, leave_policy) => {
    try {
      const enabledLeaveTypesResponse = await axios.post(
        GetenabledLeave,
        { lp_id: leave_policy },
        { headers: HEADERS }
      );

      if (enabledLeaveTypesResponse.data.response_code === "0000") {
        const enabledLeaveTypes = enabledLeaveTypesResponse.data.data;
        const leaveTypeDataPromises = enabledLeaveTypes.map(
          async (leaveType) => {
            const leaveTypeResponse = await axios.post(
              GetavailableLeave,
              { user_id: user_id, leave_type: leaveType.leave_type_id },
              { headers: HEADERS }
            );

            if (leaveTypeResponse.data.response_code === "0000") {
              return {
                leave_type_name: leaveType.leave_type_name,
                available_days: leaveTypeResponse.data.data[0].available_days,
                consumed_days: leaveTypeResponse.data.data[0].consumed_days,
                total_days: leaveTypeResponse.data.data[0].total_days,
                pending_leave: leaveTypeResponse.data.data[0].pending_leave,
              };
            }
            return null;
          }
        );
        const leaveTypeDataResults = await Promise.all(leaveTypeDataPromises);
        const filteredLeaveTypeData = leaveTypeDataResults.filter(
          (data) => data !== null
        );
        setLeaveTypeData(filteredLeaveTypeData); // Update state with fetched data
      } else {
        console.error(
          "Error fetching enabled leave types:",
          enabledLeaveTypesResponse.data.response_description
        );
      }
    } catch (error) {
      console.error("An error occurred while fetching leave data:", error);
    }
  };

  const handleSelectChange = (event) => {
    const selectedUser = event.target.value;
    setSelectedUser(selectedUser); // Update selectedUser state
    if (selectedUser) {
      const user_id = selectedUser.split("::")[0];
      const leave_policy = selectedUser.split("::")[1];
      fetchData(user_id, leave_policy); // Fetch data based on selected user
    } else {
      fetchDataDefault(); // Load default data if no user is selected
    }
  };

  useEffect(() => {
    if (chartRef1.current && chartRef2.current) {
      // Destroy previous charts if they exist
      chartInstances.current.forEach((chartInstance) => {
        chartInstance.destroy();
      });

      const ctx1 = chartRef1.current.getContext("2d");
      const ctx2 = chartRef2.current.getContext("2d");

      // Map the leaveTypeData to graph data
      const leaveTypeNames = leaveTypeData.map((data) => data.leave_type_name);
      const availableDaysData = leaveTypeData.map(
        (data) => data.available_days
      );
      const consumedDaysData = leaveTypeData.map((data) => data.consumed_days);
      const totalDaysData = leaveTypeData.map((data) => data.total_days);
      const pendingDaysData = leaveTypeData.map((data) => data.pending_leave);

      const data1 = {
        labels: leaveTypeNames,
        datasets: [
          {
            label: "Available Days",
            data: availableDaysData,
            backgroundColor: "#2d7d9f",
          },
          {
            label: "Consumed Days",
            data: consumedDaysData,
            backgroundColor: "#c8e3ec",
          },
        ],
      };

      const data2 = {
        labels: leaveTypeNames,
        datasets: [
          {
            label: "Total Days",
            data: totalDaysData,
            backgroundColor: "#2d7d9f",
          },
          {
            label: "Pending",
            data: pendingDaysData,
            backgroundColor: "#c8e3ec",
          },
        ],
      };

      // Options for both charts
      const options1 = {
        indexAxis: "x",
        plugins: {
          title: {
            display: true,
            text: "Leave Status",
          },
        },
      };

      const options2 = {
        indexAxis: "x",
        plugins: {
          title: {
            display: true,
            text: "Leave Consumption",
          },
        },
      };

      // Create new charts
      chartInstances.current = [
        new Chart(ctx1, {
          type: "bar",
          data: data1,
          options: options1,
        }),

        new Chart(ctx2, {
          type: "bar",
          data: data2,
          options: options2,
        }),
      ];
    }
  }, [leaveTypeData]); // Re-run this whenever leaveTypeData changes

  return (
    <div className="row-container p-2">
      <div className="d-flex justify-content-between" style={{ width: "100%" }}>
        <span className="title">Dashboard</span>
        {(roleName === "head" ||
          roleName === "admin" ||
          roleName === "root user") &&
        usergetall?.length > 0 ? (
          <select
            className="form-select user-list"
            onChange={handleSelectChange}
            value={selectedUser}
          >
            {usergetall.map((user, index) => (
              <option
                key={index}
                value={`${user.user_id}::${user.leave_policy}`}
                className="custom-dropdown-item"
              >
                {user.first_name}
                {user.last_name ? ` ${user.last_name}` : ""}
                {user.employee_code ? ` (${user.employee_code})` : ""}
              </option>
            ))}
          </select>
        ) : null}
      </div>

      <div className="row stat-row p-3">
        <div className="col-sm border rounded row-stat d-flex align-items-center justify-content-between">
          <div className="stat-box">
            <h6>Working Days</h6>
          </div>
          <div className="stat-box">
            <h4>{monthlydata ? monthlydata.working_days : "Loading..."}</h4>
          </div>
        </div>
        <div className="col-sm row-stat border rounded  d-flex align-items-center justify-content-between">
          <div className="stat-box">
            <h6>Public Holidays</h6>
          </div>
          <div className="stat-box">
            <h4>{monthlydata ? monthlydata.public_holidays : "Loading..."}</h4>
          </div>
        </div>
        <div className="col-sm row-stat border rounded  d-flex align-items-center justify-content-between">
          <div className="stat-box">
            <h6>Weekly Off</h6>
          </div>
          <div className="stat-box">
            <h4>{monthlydata ? monthlydata.weekly_off : "Loading..."}</h4>
          </div>
        </div>
        <div className="col-sm row-stat border rounded  d-flex align-items-center justify-content-between">
          <div className="stat-box">
            <h6>Total Days</h6>
          </div>
          <div className="stat-box">
            <h4>{monthlydata ? monthlydata.total_days : "Loading..."}</h4>
          </div>
        </div>
      </div>
      <div className="graph-section row p-3 ">
        <div className="col-md graph border rounded">
          <canvas style={{ minHeight: 120 }} ref={chartRef1}></canvas>
        </div>
        <div className="col-md graph border rounded">
          <canvas
            style={{ minHeight: 120, minWdith: 100 }}
            ref={chartRef2}
          ></canvas>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
